import { Pipe, PipeTransform } from '@angular/core';
import { NavItem } from '../models/nav-item';
import { SettingsNavItem } from '../models/settings-nav-item';

@Pipe({
  name: 'isSettingsNavItem',
  standalone: false
})
export class IsSettingsNavItemPipe implements PipeTransform {
  transform(value: NavItem): boolean {
    return value instanceof SettingsNavItem;
  }
}
